// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NRVLm","delete":"styles_delete__1BCk6","update":"styles_update__HXkV0","add":"styles_add__2v_rn"};